(() => {
  const root = document.querySelector('.pk-landing');
  if (!root) return;

  root.querySelectorAll('[data-media]').forEach((button) => button.addEventListener('click', () => {
    root.querySelectorAll('[data-media]').forEach((item) => item.classList.remove('is-active'));
    button.classList.add('is-active');
  }));

  root.querySelector('[data-pk-scroll-buy]')?.addEventListener('click', () => {
    document.querySelector('#PawKindProductForm')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  const form = root.querySelector('#PawKindProductForm');
  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[name="add"]');
    const originalLabel = button?.textContent;

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding to cart…';
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });

      if (!response.ok) throw new Error('Unable to add item');

      if (button) button.textContent = 'Added — opening cart';
      window.location.assign('/cart');
    } catch (error) {
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalLabel || 'Add to cart';
      }
      window.location.assign('/cart');
    }
  });
})();